import { createContext, type ComponentChildren } from 'preact';
import { useContext } from 'preact/hooks';
import type { AboutSubscriptions } from '@/domain/Subscription.ts';

export type StaticContent = {
  aboutSubscriptions?: AboutSubscriptions;
};

const StaticContentContext = createContext<StaticContent | undefined>(
  undefined
);

export type StaticContentProviderProps = StaticContent & {
  children: ComponentChildren;
};

export function StaticContentProvider({
  children,
  ...props
}: StaticContentProviderProps) {
  return (
    <StaticContentContext.Provider value={props}>
      {children}
    </StaticContentContext.Provider>
  );
}

export default function useStaticContent(): StaticContent {
  const context = useContext(StaticContentContext);

  if (!context) {
    throw new Error(
      'useStaticContent must be used within StaticContentProvider'
    );
  }
  return context;
}
